import { DateTime } from 'luxon'

/**
 * How far ahead a premise can plan a service and a customer can book it, in calendar months. One
 * Seiri-wide number for every premise and service; a per-premise or per-service setting is a later
 * decision (docs/public-booking.md).
 */
export const BOOKING_HORIZON_MONTHS = 6

/**
 * The last instant of the booking horizon: the end of the day `BOOKING_HORIZON_MONTHS` from `now`, in
 * the premise's timezone. A manager may let a service run until then and a customer may book until
 * then, so everything planned can be booked. A day the target month lacks (31 August + 6 months)
 * falls back to that month's last day.
 */
export function bookingHorizonEnd(now: Date, timezone: string): Date {
  return DateTime.fromJSDate(now).setZone(timezone).plus({ months: BOOKING_HORIZON_MONTHS }).endOf('day').toJSDate()
}

/** The longest window one public slots request may cover. The widget asks for 30 days at a time. */
export const PUBLIC_SLOTS_MAX_RANGE_DAYS = 31
